import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import { useEffect } from 'react';
import { dynatraceTrackInstantAction } from 'utils/dynatrace';

export const DynatraceTriggerAction = ({
  action,
}: {
  action: DYNATRACE_ACTIONS;
}) => {
  useEffect(() => {
    dynatraceTrackInstantAction(action);
  }, []);
  return <></>;
};
